import type { SVGProps } from 'react';

export function QueenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 1c.422 0 .835.12 1.193.345.358.226.645.549.83.931a2.28 2.28 0 0 1-.255 2.391l.892 2.248 1.914-1.93a2.29 2.29 0 0 1 .391-1.964 2.26 2.26 0 0 1 1.784-.888c.53 0 1.044.188 1.45.532a2.281 2.281 0 0 1 .496 2.878 2.25 2.25 0 0 1-1.188.992L17.606 17.07c-.043.238-.16.456-.336.622a1.12 1.12 0 0 1-.637.3l-.134.008H7.5a1.12 1.12 0 0 1-.668-.221 1.13 1.13 0 0 1-.407-.578l-.032-.131-1.9-10.535a2.25 2.25 0 0 1-1.035-.765 2.277 2.277 0 0 1 .749-3.376 2.24 2.24 0 0 1 2.449.237 2.283 2.283 0 0 1 .769 2.355l1.913 1.929.893-2.248a2.276 2.276 0 0 1 .575-3.322A2.24 2.24 0 0 1 12 1M18.859 19H5.144a1.23 1.23 0 0 0-.808.293.94.94 0 0 0-.334.707c0 .53.24 1.04.669 1.414.429.375 1.01.586 1.616.586h11.43c.56 0 1.1-.18 1.52-.506.418-.326.685-.775.75-1.262l.013-.174a.9.9 0 0 0-.067-.4 1 1 0 0 0-.243-.344 1.2 1.2 0 0 0-.378-.232 1.3 1.3 0 0 0-.453-.082" />
    </svg>
  );
}
